import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2018 } from "../../../../data/Convenios/dataConvenios";

const Convenios2018 = () => <ConveniosYearPage year={2018} data={convenios2018} />;

export default Convenios2018;